import { stack as d3_stack } from 'd3-shape'
import { extent as d3_extent, max as d3_max, min as d3_min } from 'd3-array'
import { convertRowsToData } from '../utils/dataUtils'

export default function PyramidChartDataController(rows, config, hiddenItems) {
  let headers = rows[0]
  let propperHeaders = ['id', ...headers.slice(1)]

  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], 2)

  let keys = data.reduce((res, d) => {
    d.value.forEach(dd => res.push(dd.id))
    return res
  }, [])
  keys = keys.filter((value, index, self) => self.indexOf(value) === index)
  let res = keys.map((key, i) => {
    return {
      id: key,
      innerIndex: i,
      value: data
        .map(dd => {
          let cand = dd.value.find(ddd => ddd.id === key)
          return {
            id: cand.parentId,
            parentId: cand.id,
            value: cand.value,
          }
        })
        .reverse(),
    }
  })
  if (hiddenItems && hiddenItems.length > 0)
    res = res.filter(resItem => !hiddenItems.includes(resItem.id))

  return res
}
